import React from 'react';
import BusinessDaysConfigurationForm from './BusinessDaysConfigurationForm';
import { SettingsBreadcrumbs } from '../settingsModule';
import InnerBlock from '../../shared/web/layout/InnerBlock';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';

export default function BusinessDaysConfigurationPage() {
  return (
    <>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Holidays Observed" />
      </SettingsBreadcrumbs>
      <InnerBlock title="Holidays Observed">
        <BusinessDaysConfigurationForm />
      </InnerBlock>
    </>
  );
}
